module.exports = __webpack_public_path__ + "media/img/frontend_application/payment-icon-4fcf138b8bcd2cceaef500d22dbeee41.png";